import { render, staticRenderFns } from "./card.vue?vue&type=template&id=dccf6b98&scoped=true"
import script from "./card.vue?vue&type=script&lang=ts"
export * from "./card.vue?vue&type=script&lang=ts"
import style0 from "./card.vue?vue&type=style&index=0&id=dccf6b98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dccf6b98",
  null
  
)

export default component.exports